import * as React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import { useFiltersState } from '~/hooks/use-filters-state'
import Button from '~/truck/button'

export interface FooterProps {
  onShowClick: () => void
}

const Container = styled.div`
  bottom: 0;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  left: 0;
  padding: ${props => props.theme.spacing.comfortable}px;
  position: sticky;
  right: 0;

  ${up('lg')} {
    position: static;
  }
`

export function Footer(props: FooterProps) {
  const { onShowClick } = props

  const { totalOfResults } = useFiltersState()

  return (
    <Container>
      <Button color="secondary" onClick={() => onShowClick()}>
        Mostrar {totalOfResults} productos
      </Button>
    </Container>
  )
}
